import { LoginStateEnum, useAuth } from 'modules/auth/auth.context';
import { LoadingPage } from 'modules/pages/loading-page';
import * as React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

export function ProtectedRoute({
  children,
  path,
  exact = false,
  props,
}: {
  children: React.ReactNode;
  path: string;
  exact?: boolean;
  props?: Omit<RouteProps, 'path'>;
}) {
  const auth = useAuth();

  switch (auth.loginState) {
    case LoginStateEnum.LOADING:
      return (
        <Route {...props} path={path} exact={exact}>
          <LoadingPage />
        </Route>
      );
    case LoginStateEnum.LOGGED_IN:
      return (
        <Route {...props} path={path} exact={exact}>
          {children}
        </Route>
      );
    case LoginStateEnum.LOGGED_OUT:
      return <Redirect to="/login" />;
  }
}
